import { render, staticRenderFns } from "./StrdD_HppItems.vue?vue&type=template&id=2772d178"
import script from "./StrdD_HppItems.vue?vue&type=script&lang=js"
export * from "./StrdD_HppItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports